<template>
    <el-table :data="tableData" stripe style="width: 100%" :cell-style="{'text-align':'center'}">
        <el-table-column prop="openNum" label="期号" align="center" width="94">
        </el-table-column>
        <el-table-column prop="openTime" label="时间" align="center">
            <template slot-scope="scope">
                {{ getTime(scope.row.openTime) }}
            </template>
        </el-table-column>
        <el-table-column prop="result" label="开奖" align="center">
            <template slot-scope="scope">
                <template v-if="getResult(scope.row.result,0)===''">
                        --
                </template>
                <template v-else>
                    <div  class="openprize">
                        <div >{{ getResult(scope.row.result,0) }}</div>
                        <div class="ml5s"><span>+</span></div>
                        <div >{{ getResult(scope.row.result,1) }}</div>
                        <div class="ml5s"><span>+</span></div>
                        <div >{{ getResult(scope.row.result,2) }}</div>
                        <div class="ml5s"><span>=</span></div>
                        <div :class="getColor(getResult(scope.row.result,3))==1?'greenc':getColor(getResult(scope.row.result,3))==2?'redc':getColor(getResult(scope.row.result,3))==3?'bluec':''" >{{ getResult(scope.row.result,3) }}</div>
                    </div>
                </template>
            </template>
        </el-table-column>
        <el-table-column prop="num" label="预测" align="center">
            <template slot-scope="scope">
                <span v-if="!getResult(scope.row.result,3)" style="background-color: #F56C6C;"  class="resu">{{ getGuessValue(scope.row.guess2) }}</span>
                <span v-else>{{ getGuessValue(scope.row.guess2) }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="num" label="结果" align="center">
            <template slot-scope="scope">
                <template v-if="getResult(scope.row.result,3) ==''">
                    <span style="background-color: #409EFF;" class="resu" >刷新</span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==2">
                    <span style="background-color: #F56C6C;" class="resu">杀组</span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==1">
                    <span style="background-color: #67C23A;" class="resu">输了</span>
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        tableData: {
            type: Array,
            default: null,
            require: true
        }
    },
    methods: {
        getColor(getsum){
            let a= getsum.toString().padStart(2, '0');
            const array1 = ['00', '06', '05', '11', '16', '17', '21', '22'];
            const array2 = ['01', '02', '07', '08', '12', '13', '18', '19', '23', '24'];
            const array3 = ['03', '04', '09', '10', '14', '15', '20', '25', '26', '27'];
            if (array1.includes(a)) {
                return 1;
            } else if (array2.includes(a)) {
                return 2;
            } else if (array3.includes(a)) {
                return 3;
            } else {
                return 4;
            }
        },
        getResult(data,indx){
            if (data && data.length == 3) {
                switch (indx) {
                    case 0: {
                        return Number(data[0]);
                    }
                    case 1: {
                        return Number(data[1]);
                    }
                    case 2: {
                        return Number(data[2]);
                    }
                    case 3: {
                        let sum= Number(data[0]) + Number(data[1]) + Number(data[2]);
                        return  sum.toString().padStart(2, '0');
                    }
                }
            }
            return ""
        },
        getTime(time){
           return time.slice(11,19)
        },
        getGuessValue(data) {
            let guessData = ""
            switch (data[1]) {
                case 0: {
                    guessData += "大单"
                    break
                }
                case 1:
                    {
                        guessData += "小单"
                        break
                    }
                    case 2:
                    {
                        guessData += "大双"
                        break
                    }
                    case 3:
                    {
                        guessData += "小双"
                        break
                    }
            }
            return guessData

        },
        getGuessResult(data) {
            let result = this.getResult(data.result,3);
            let forecast= this.getGuessValue(data.guess2);
            if((result%2==1 && result>=14) && forecast==='大单' || (result%2==0 && result>=14) && forecast==='大双' || (result%2==1 && result<=13) && forecast==='小单' || (result%2==0 && result<=13) && forecast==='小双'){
                return 1;
            }else{
                return 2;
            }
        },
        isBigNum(data) {
            if (data.sumResult >= 14) return true
            return false
        },
        isOddNumber(data) {
            if (data.sumResult == 0 || (data.sumResult % 2 == 0)) return false
            return true
        },
        isVerySmall(data) {
            if (data.sumResult <= 5) return true
            return false
        },
        isVersyBig(data) {
            if (data.sumResult >= 23) return true
            return false
        },
    }
}
</script>